import React from "react";
import "./ContactComponents.css";

const MapPlaceholder = ({ location }) => {
  return (
    <div className="map-container">
      <iframe
        title={`${location.name} map`}
        src={location.mapEmbedUrl}
        loading="lazy"
        allowFullScreen
        referrerPolicy="no-referrer-when-downgrade"
      />

      <div className="map-cta">
        <span className="map-pin">📍</span>

        <div className="map-cta-text">
          <strong>{location.name}</strong>
          <span>{location.city}</span>
        </div>

        {location.directionsUrl && (
          <a
            href={location.directionsUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="map-directions-btn"
          >
            Cómo llegar
          </a>
        )}
      </div>
    </div>
  );
};

export default MapPlaceholder;
